import {
  getPutApiV1ThreeLetterCodeClientAdminsUsersIdMutationFetcher,
  getPutApiV1ThreeLetterCodeClientAdminsUsersIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  PutApiV1ThreeLetterCodeClientAdminsUsersId200,
  PutApiV1ThreeLetterCodeClientAdminsUsersIdBody,
} from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

type ReturnType = {
  trigger: (
    arg: PutApiV1ThreeLetterCodeClientAdminsUsersIdBody
  ) => Promise<PutApiV1ThreeLetterCodeClientAdminsUsersId200>;
  isMutating: boolean;
};

type IUsePutClientUser = (
  threeLetterCode: string,
  userId: number,
  options?: {
    onSuccess?: (data: PutApiV1ThreeLetterCodeClientAdminsUsersId200) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => ReturnType;

/**
 * 利用者情報更新フック
 *
 * @param threeLetterCode - 3文字コード（認証情報）
 * @param userId - 利用者ID
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePutClientUser: IUsePutClientUser = (threeLetterCode, userId, options) => {
  const { trigger, isMutating } = useMutation(
    getPutApiV1ThreeLetterCodeClientAdminsUsersIdMutationKey(threeLetterCode, userId),
    getPutApiV1ThreeLetterCodeClientAdminsUsersIdMutationFetcher(threeLetterCode, userId),
    options
  );

  return { trigger, isMutating };
};
